import { render, staticRenderFns } from "./card-b.vue?vue&type=template&id=1bf6fd5c&scoped=true&lang=pug&"
import script from "./card-b.vue?vue&type=script&lang=js&"
export * from "./card-b.vue?vue&type=script&lang=js&"
import style0 from "./card-b.vue?vue&type=style&index=0&id=1bf6fd5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6fd5c",
  null
  
)

export default component.exports